var BaseView = require('../lib/model-binder');
var _ = require('underscore');
var $ = require('jquery');
const dateFormat = require('dateformat');
// var toastr = require('toastr');
// const toastr = require('../helpers/toastr-config');
const notifications = require('../helpers/custom-notifications');
var SubtitleScope = require('../scopes/subtitle');
var STATUSES = SubtitleScope.VARIABLES.STATUSES;
var CLASS_NAMES = SubtitleScope.VARIABLES.CLASS_NAMES;

var reader = require('../helpers/reader');
var dispatcher = require('../dispatcher');

var ContextMenu = require('./context-menu');

var template = require('../templates/subtitle-item.jade');

var parent = BaseView.prototype;

module.exports = BaseView.extend({
	template: template(),

	events: {
		'click': 'selectRow',
		'dblclick': 'editSubtitle',
		contextmenu: 'onRightClick'
	},

	model: null,
	preventContextMenu: false,

	initialize: function (options) {
		_.extend(this, options);

		_.bindAll(this, 'getCurrentVal', 'fillValues', 'statusClass'
			, 'onRightClick', 'checkInitData', 'getDuration', 'getRows',
			'getIndex', 'getTimeStart', 'getTimeEnd', 'isUnknown');

		this.initEventListeners();

		parent.initialize.apply(this, arguments);

	},

	initEventListeners: function () {
		this.listenTo(dispatcher, dispatcher.events.UPDATE_SUB, this.fillValues);
		this.listenTo(dispatcher, dispatcher.events.UPDATE_LAST_SYNC_TIME, this.updateLastSync);

		this.listenTo(dispatcher, dispatcher.events.DISABLE_KEYBOARD_CONTROLS, _.bind(function () {
			this.preventContextMenu = true;
		}, this));

		this.listenTo(dispatcher, dispatcher.events.ENABLE_KEYBOARD_CONTROLS, _.bind(function () {
			this.preventContextMenu = false;
		}, this));

		this.listenTo(dispatcher, dispatcher.events.DESTROY_ITEMS, this.fillValues);

		this.listenTo(this.model, 'change', this.fillValues);
	},

	updateLastSync: function () {
		var now = new Date();
		this.model.set('captionLastUpdate', dateFormat(now, "d/mm/yy HH:MM:ss"));
	},

	// Helper function for text direction detection (same logic as in subtitle-editor.js)
	detectTextDirection: function(text) {
		if (!text || text.trim().length === 0) {
			return { direction: 'rtl' };
		}
		
		// Comprehensive RTL character detection
		// Hebrew: U+0590–U+05FF
		// Arabic: U+0600–U+06FF, U+0750–U+077F, U+08A0–U+08FF, U+FB50–U+FDFF, U+FE70–U+FEFF
		// Yiddish uses Hebrew characters: U+0590–U+05FF
		// Persian/Farsi uses Arabic script: U+0600–U+06FF
		// Urdu uses Arabic script: U+0600–U+06FF
		var rtlRegex = /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
		
		if (rtlRegex.test(text)) {
			// If any RTL character is present (Hebrew, Arabic, Yiddish, Persian, Urdu, etc.)
			return { direction: 'rtl' };
		} else {
			// Pure LTR (English, etc.)
			return { direction: 'ltr' };
		}
	},

	// Apply text direction to a specific element (keep text centered)
	applyTextDirection: function($element, text) {
		var directionInfo = this.detectTextDirection(text);
		$element.css({
			'direction': directionInfo.direction,
			'unicode-bidi': 'isolate'
		});
	},

	selectRow: function (e) {
		dispatcher.emit(dispatcher.events.SELECT_SUBTITLE, e);
	},

	render: function () {
		this.setElement(this.template);

		this.modelBinder.bind(this.model, this.$el, {
			
			id: [
				////id:
				{
					selector: '.time',
					elAttribute: 'title',
					converter: this.getDuration
				},
				{
					selector: '.original',
					elAttribute: 'title',
					converter: () => {
						var rows = this.getRows();
						return 'Line1: ' + rows.row1.original.length + '/' + reader.maxCharactersInLine + ' Line2: ' + rows.row2.original.length + '/' + reader.maxCharactersInLine;
					}
				},
				{
					selector: '.edited',
					elAttribute: 'title',
					converter: () => {
						var rows = this.getRows();
						return 'Line1: ' + rows.row1.edit.length + '/' + reader.maxCharactersInLine + ' Line2: ' + rows.row2.edit.length + '/' + reader.maxCharactersInLine;
					}
				},
				//frameStart
				{
					selector: '.time-start',
					converter: this.getTimeStart
				},
				////frameEnd
				{
					selector: '.time-end',
					converter: this.getTimeEnd
				},
				{
					selector: '.original',
					elAttribute: 'class',
					converter: this.isUnknown
				},

			],
			status: {
				selector: '',
				elAttribute: 'class',
				converter: this.statusClass
			},
			// id: {
			// 	selector: '',
			// 	elAttribute: 'class',
			// 	converter: this.setGuid
			// },

			hasBox: {
				selector: '',
				elAttribute: 'class',
				converter: function (dir, value) {
					return value ? 'has-box' : '';
				}
			},

		});

		
		this.fillValues();
		this.checkInitData();

		return this;
	},

	checkInitData: function () {
		if (typeof window._checkedItemInitData !== 'undefined') return;

		var progress = 0;
		if (localStorage.hasOwnProperty('capNsub-player-progress'))
			progress = localStorage.getItem('capNsub-player-progress') * reader.frameRate;

		var model = this.model.getCurrentModel();
		var frameStart = parseInt(model.get('frameStart'));
		var frameEnd = parseInt(model.get('frameEnd'));

		if (frameStart <= progress && frameEnd >= progress) this.checkActiveFrame();
	},

	checkActiveFrame: function () {
		if (this.model.get('status') == STATUSES.DELETED) return;

		if (!this.model.collection) return false;

		var index = this.model.collection.indexOf(this.model);

		_.debounce(_.bind(function () {
			this.$el.addClass('selected');
			dispatcher.emit(dispatcher.events.SCROLL_TO, index);
			dispatcher.emit(dispatcher.events.UPDATE_SUB_DISPLAY, this.model, true);

			window._checkedItemInitData = true;
		}, this))();
	},

	getIndex: function () {
		if (this.model.get('status') == STATUSES.DELETED) {
			return null;
		} 

		try {
			return this.model.getSubtitleIndex({shouldIgnoreDeleted: true}) + 1;
		} catch (e) {
			return -1;
		}

		// var index = this.model.collection.indexOf(this.model);
		// return (parseInt(index) + 1);
	},

	getTimeStart: function () {
		var model = this.model.getCurrentModel();
		return reader.convertToTime(model.get('frameStart'));
	},

	getTimeEnd: function () {
		var model = this.model.getCurrentModel();
		return reader.convertToTime(model.get('frameEnd'));
	},

	getDuration: function () {
		var model = this.model.getCurrentModel();
		return reader.convertMinToTime(model.get('frameEnd') - model.get('frameStart'))
	},
	isUnknown: function () {
		var model = this.model.getCurrentModel();
		var row1 = model.get('row1');
		var row2 = model.get('row2');

		return (row1 && (row1.indexOf('???') !== -1 || row1.indexOf('؟؟؟') !== -1)) ||
           (row2 && (row2.indexOf('???') !== -1 || row2.indexOf('؟؟؟') !== -1)) ? 'unknown' : '';
	},

	getCurrentVal: function (dir, value, key, model, selector) {
		var returnVal = '';

		var edits = this.model.get('edits');
		var currentModel = this.model;

		if ($(selector).hasClass('row1-original')) {
			returnVal = currentModel.get('row1');
		} else if ($(selector).hasClass('row2-original')) {
			returnVal = currentModel.get('row2');
		}

		return returnVal;
	},
	getRows: function() {
		var stack = this.model.get('editStack');
		var stackPosition = this.model.get('editStackPosition');
		var originalModel = stack.at(0);
		var editModel = stackPosition != 0 && this.model.getCurrentModel();

		return {
			row1: {
				original: originalModel.get('row1'),
				edit: editModel && editModel.get('row1') || ''
			},
			row2: {
				original: originalModel.get('row2'),
				edit: editModel && editModel.get('row2') || ''
			}
		}
	},

	fillValues: function () {
		var editedModel, originalModel;
		var stack = this.model.get('editStack');
		var stackPosition = this.model.get('editStackPosition');

		originalModel = stack.at(0);

		if (stackPosition != 0) {
			editedModel = this.model.getCurrentModel();
		}

		if (editedModel &&
			(editedModel.get('row1') != originalModel.get('row1') ||
				editedModel.get('row2') != originalModel.get('row2') ||
				editedModel.get('italic') != originalModel.get('italic'))) {

			var row1Edited = editedModel.get('row1');
			var row2Edited = editedModel.get('row2');

			this.$('.row1-edited').html(row1Edited);
			this.$('.row2-edited').html(row2Edited);
			
			// Apply direction detection to edited content
			this.applyTextDirection(this.$('.row1-edited'), row1Edited);
			this.applyTextDirection(this.$('.row2-edited'), row2Edited);

			if (editedModel.get('italic'))
				this.$('.text.edited').addClass('italic');
			else this.$('.text.edited').removeClass('italic');
		} else {
			this.$('.row1-edited, .row2-edited').html('');
		}

		var row1Original = originalModel.get('row1');
		var row2Original = originalModel.get('row2');
		this.$('.row1-original').html(row1Original);
		this.$('.row2-original').html(row2Original);
		
		// Apply direction detection to original content
		this.applyTextDirection(this.$('.row1-original'), row1Original);
		this.applyTextDirection(this.$('.row2-original'), row2Original);

		if (originalModel.get('italic'))
			this.$('.text.original').addClass('italic');
		else
			this.$('.text.original').removeClass('italic');

		this.$('.duration-time').html(this.getDuration());
		this.$('.time-start').html(this.getTimeStart());
		this.$('.time-end').html(this.getTimeEnd());
		this.$('.title-number').html(this.getIndex());

		this.$('#lastSync').html("Test");
	},

	editSubtitle: function () {
		if (this.preventContextMenu) {
			dispatcher.emit(dispatcher.events.PULL_IN_VIEWPORT, true, true);
			return;
		}

		var index = this.model.collection.indexOf(this.model);

		if (this.model.get('status') == STATUSES.DELETED)  {
			notifications.error("this subtitle is deleted. Please restore it first.");
			return;
		}

		this.$el.addClass('editing');

		dispatcher.emit(dispatcher.events.SELECT_SUBTITLE, index);

		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
		dispatcher.emit(dispatcher.events.EDIT_SUBTITLE);
	},

	onRightClick: function (e) {
		e.preventDefault();

		if (this.preventContextMenu) return;
		if ($('body').find('.context-menu').length) return;

		var $target = e.target.className.indexOf('col') !== -1 ? $(e.target) : $(e.target).parents('.col');

		if (!$target || e.target.className == 'play') return;

		var index = this.model.collection.indexOf(this.model);

		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
		dispatcher.emit(dispatcher.events.SELECT_SUBTITLE, index);

		var contextMenu = new ContextMenu({
			model: this.model
		});
		contextMenu.$el.appendTo($target);

		contextMenu.$el.css({
			top: 20,
			left: e.clientX - $target.offset().left
		});
	},

	statusClass: function () {
		var status = this.model.get('status');

		this.$el.removeClass('status-' + CLASS_NAMES[this.model.previous('status')]);

		this.$el.addClass('status-' + CLASS_NAMES[status]);
	},

	destroy_view: function () {
		// COMPLETELY UNBIND THE VIEW
		this.undelegateEvents();

		this.$el.removeData().unbind();

		// Remove view from DOM
		this.remove();
		Backbone.View.prototype.remove.call(this);
	}
});


// WEBPACK FOOTER //
// ./app/views/subtitle-item.js